import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { Link } from 'react-router-dom';

import CustomDate from '../../misc/CustomDate';

const EventInfoCard = props => {
  const { eventInfo, bestOfAvailable, onExpandBestof, eventBannerActAsLink } = props;

  return (
    <div className="col-xs-16 col-sm-6 col-sm-offset-2">
      <div className="event-info-card-container">
        <div className="event-info-card-banner">
          {eventBannerActAsLink ? (
            <Link to={`/event/${eventInfo.sgId}`} replace={true}>
              <div
                className="absolute-cover"
                style={{ backgroundImage: `url(${eventInfo.banner})` }}
              />
            </Link>
          ) : (
            <div
              className="absolute-cover"
              style={{ backgroundImage: `url(${eventInfo.banner})` }}
            />
          )}
        </div>
        <div className="event-info-card-info">
          <div className="event-info-card-name">{eventInfo.name}</div>
          <div className="event-info-card-details">
            <p>
              <span>{eventInfo.location}</span>
              <CustomDate value={eventInfo.beginsAt} />
            </p>
            <a target="_blank" href={eventInfo.hostHomepageUrl}>
              {eventInfo.hostHomepageName}
            </a>
          </div>
          {bestOfAvailable && (
            <div className="event-info-card-expand-bestof" onClick={onExpandBestof}>
              <FormattedMessageWrappedInSpan
                id="eventInfoCard.bestOfLink"
                defaultMessage="Bestof-Gallery"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

EventInfoCard.propTypes = {
  eventInfo: PropTypes.object,
  bestOfAvailable: PropTypes.bool,
  eventBannerActAsLink: PropTypes.bool,
  onExpandBestof: PropTypes.func,
};

export { EventInfoCard };

export default createFragmentContainer(EventInfoCard, {
  eventInfo: graphql`
    fragment EventInfoCard_eventInfo on Event {
      id
      sgId
      beginsAt
      banner
      hostHomepageName
      hostHomepageUrl
      location
      name
      predecessorEvent {
        name
      }
    }
  `,
});
